import React from 'react'
import { Link } from 'react-router-dom'
import { hasOpenQuestions } from '../../utilities/helpers'
import { formPagePath } from '../../utilities/route'
import styled from 'styled-components'
import { TABLET, LAPTOP } from '../../utilities/breakpoints'

const NavStatistics = ({
  activePage,
  surveyId,
  languageCode,
  useTranslate,
  questionnaire
}) => {

  const to = formPagePath(languageCode, surveyId, 'finish');
  const toStatistics = formPagePath(languageCode, surveyId, 'finish', 'themes');
  const toDrivers = formPagePath(languageCode, surveyId, 'finish', 'drivers');
  const toStatements = formPagePath(languageCode, surveyId, 'finish', 'statements');
  const toOpenQuestions = formPagePath(languageCode, surveyId, 'finish', 'open-questions');
  const toComparativeReports = formPagePath(languageCode, surveyId, 'finish', 'comparative-reports');

  const {catalysts, canViewAfterGame, isAfterGameGuest} = questionnaire;

  return (
    <NavContainer className="finish-page__intro__nav">
      <Link
        to={to}
        className={`nav-item btn ${activePage === "overview" ? "active" : ""}`}
      >
        {useTranslate("data_vault.overview")}
      </Link>
      <Link
        to={toStatistics}
        className={`nav-item btn ${activePage === "themes" ? "active" : ""}`}
      >
        {useTranslate("data_vault.themes")}
      </Link>
      <Link
        to={toDrivers}
        className={`nav-item btn ${activePage === "drivers" ? "active" : ""}`}
      >
        {useTranslate("data_vault.drivers")}
      </Link>
      <Link
        to={toStatements}
        className={`nav-item btn ${activePage === "statements" ? "active" : ""}`}
      >
        {useTranslate("data_vault.statements")}
      </Link>
      {hasOpenQuestions(catalysts) &&
        <Link
          to={toOpenQuestions}
          className={`nav-item btn ${activePage === "open-questions" ? "active" : ""}`}
        >
          {useTranslate("data_vault.open_answers")}
        </Link>
      }
      {(canViewAfterGame || isAfterGameGuest) &&
        <Link
          to={toComparativeReports}
          className={`nav-item btn ${activePage === "comparative-reports" ? "active" : ""}`}
        >
          {useTranslate("data_vault.comparative_reports")}
        </Link>
      }
    </NavContainer>
  )
}

export default NavStatistics;

const NavContainer = styled.div`
  background-color:#ffffff;
  border-radius: 10px;
  padding: 5px;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: stretch;
  
  .nav-item {
    color: black;
    background-color: #fff;
    border-radius: 10px;
    padding: 5px 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;

    &.active {
      background: #F58220;
      color: #fff;
    }

    &:hover:not(.active) {
      color: #F58220;
    }

    &:active,
    &:focus {
      outline: none;
      box-shadow: none;
    }
    
    @media${TABLET} {
      padding: 5px 20px;
      font-size: 16px;
    }
    
    @media${LAPTOP} {
      padding: 10px 26px;
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/navigation/nav-statistics.js